
import { Component, Vue, Prop } from 'vue-property-decorator';

import moment from 'moment';
import defaultColors from '@/colors';
moment.locale('es');

@Component({
  watch: {
    GraphsData(newVal, oldVal) {
      (this as any).initGraphs(newVal);
    },
  },
  components: {
    DoughnutGraph: () => import('@/components/DoughnutGraph.vue'),
    BarGraph: () => import('@/components/BarGraph.vue'),
  },
  computed: {},
  filters: {},
})
export default class ClaimsGraphs extends Vue {
  @Prop(Object) readonly GraphsData;
  @Prop(Function) readonly seeMoreClaimsOperations;
  @Prop(Function) readonly claimsFilters;
  showMoreClaimsGraphs: boolean = false;
  showMoreLabel: string = 'Ver reportes de clientes y ramos';
  iconExpanded: string = require('@/assets/ico-expand.svg');
  iconCollapsed: string = require('@/assets/ico-collapse.svg');
  databoxes: any = {
    claimsState: {
      isExpanded: false,
      svgPath: this.iconExpanded,
    },
    approvedPerClient: {
      isExpanded: false,
      svgPath: this.iconExpanded,
      limit: 4,
    },
    approvedPerBranch: {
      isExpanded: false,
      svgPath: this.iconExpanded,
      limit: 4,
    },
    claimsOarPerBusiness: {
      isExpanded: false,
      svgPath: this.iconExpanded,
      limit: 4,
    },
    claimsOarPerBranch: {
      isExpanded: false,
      svgPath: this.iconExpanded,
      limit: 4,
    },
    claimsCountPerBranch: {
      isExpanded: false,
      svgPath: this.iconExpanded,
      limit: 4,
    },
  };
  data: any = {
    approvedPerClient: {
      labels: [],
      datasets: {
        backgroundColor: defaultColors,
        data: [],
      },
    },
    approvedPerBranch: {
      labels: [],
      datasets: {
        backgroundColor: defaultColors,
        data: [],
      },
    },
    claimsState: {
      labels: [],
      datasets: {
        backgroundColor: ['#32AE80', '#F3C911', '#DC5A57'],
        data: [],
      },
    },
    claimsOarPerBusiness: {
      labels: [],
      datasets: {
        backgroundColor: defaultColors,
        data: [],
      },
    },
    claimsOarPerBranch: {
      labels: [],
      datasets: {
        backgroundColor: defaultColors,
        data: [],
      },
    },
    claimsCountPerBranch: {
      labels: [],
      datasets: {
        backgroundColor: defaultColors,
        data: [],
      },
    },
    lastOperations: [],
  };
  ready: boolean = true;
  currencies: any = [];
  dates: any = [];
  claimsGraphFilters: any = {
    claimsPerBusiness: {
      currency: 1,
      validity: 1,
    },
    claimsPerBranch: {
      currency: 1,
      validity: 1,
    },
    countClaimsPerBranch: {
      currency: 1,
      validity: 1,
    },
  };

  async mounted() {
    await this.initGraphs(this.GraphsData);
  }

  resetData() {
    this.ready = false;
    this.data.approvedPerClient = {
      labels: [],
      datasets: {
        backgroundColor: defaultColors,
        data: [],
      },
    };
    this.data.approvedPerBranch = {
      labels: [],
      datasets: {
        backgroundColor: defaultColors,
        data: [],
      },
    };
    this.data.claimsState = {
      labels: [],
      datasets: {
        backgroundColor: ['#32AE80', '#F3C911', '#DC5A57'],
        data: [],
      },
    };
    this.data.claimsOarPerBusiness = {
      labels: [],
      datasets: {
        backgroundColor: defaultColors,
        data: [],
      },
    };
    this.data.claimsOarPerBranch = {
      labels: [],
      datasets: {
        backgroundColor: defaultColors,
        data: [],
      },
    };
    this.data.claimsCountPerBranch = {
      labels: [],
      datasets: {
        backgroundColor: defaultColors,
        data: [],
      },
    };
    this.data.lastOperations = [];
    this.$nextTick(() => {
      this.ready = true;
    });
  }

  async initGraphs(newVal) {
    if (!newVal) return;

    let i = 0;
    newVal.claimsApprovedPerClient.forEach((element) => {
      if (this.databoxes.approvedPerClient.limit !== -1)
        if (i >= this.databoxes.approvedPerClient.limit) return;
      this.data.approvedPerClient.labels.push(
        element.subscriptor && element.subscriptor.fullname
      );
      this.data.approvedPerClient.datasets.data.push(element.approved);
      i++;
    });

    i = 0;
    newVal.claimsApprovedPerBranch.forEach((element) => {
      this.data.approvedPerBranch.labels.push(element.request.branch.title);
      this.data.approvedPerBranch.datasets.data.push(element.approved);
      if (this.databoxes.approvedPerClient.limit !== -1)
        if (i >= this.databoxes.approvedPerClient.limit) return;
      i++;
    });

    i = 0;
    newVal.claimsOarPerBusiness.forEach((element) => {
      if (this.databoxes.claimsOarPerBusiness.limit !== -1)
        if (i >= this.databoxes.claimsOarPerBusiness.limit) return;
      this.data.claimsOarPerBusiness.labels.push(element.companyName);
      this.data.claimsOarPerBusiness.datasets.data.push(element.contracts);
      i++;
    });

    i = 0;
    newVal.claimsOarPerBranch.forEach((element) => {
      if (this.databoxes.claimsOarPerBranch.limit !== -1)
        if (i >= this.databoxes.claimsOarPerBranch.limit) return;
      this.data.claimsOarPerBranch.labels.push(element.branchName);
      this.data.claimsOarPerBranch.datasets.data.push(element.contracts);
      i++;
    });

    i = 0;
    newVal.claimsCountPerBranch.forEach((element) => {
      if (this.databoxes.claimsCountPerBranch.limit !== -1)
        if (i >= this.databoxes.claimsCountPerBranch.limit) return;
      this.data.claimsCountPerBranch.labels.push(element.branchName);
      this.data.claimsCountPerBranch.datasets.data.push(element.count);
      i++;
    });

    this.data.claimsState.datasets.data.push(newVal.claimsApproved);
    this.data.claimsState.datasets.data.push(newVal.claimsPending);
    this.data.claimsState.datasets.data.push(newVal.claimsRejected);
    this.data.claimsState.labels.push('Activas');
    this.data.claimsState.labels.push('Pendientes');
    this.data.claimsState.labels.push('Rechazadas');
    this.data.lastOperations = newVal.claimsLastOperations.map((req) => ({
      operation: req.content,
      nombre:
        (req.admin && req.admin.fullname) ||
        (req.subscriptor && req.subscriptor.fullname),
      fecha: moment(req.createdAt).format('DD/MM/YYYY'),
    }));

    this.currencies = newVal.allCurrencies;
    this.dates = newVal.allDates;
  }

  toggleShowMoreClaimsGraphs() {
    this.showMoreClaimsGraphs = !this.showMoreClaimsGraphs;

    if (this.showMoreClaimsGraphs)
      this.showMoreLabel = 'Ocultar reportes de clientes y ramos';
    else this.showMoreLabel = 'Ver reportes de clientes y ramos';
  }

  async toggleExpand(index) {
    this.databoxes[index].isExpanded = !this.databoxes[index].isExpanded;
    if (this.databoxes[index].isExpanded)
      this.databoxes[index].svgPath = this.iconCollapsed;
    else this.databoxes[index].svgPath = this.iconExpanded;

    this.resetData();
    await this.initGraphs(this.GraphsData);
  }

  graphFilters() {
    this.claimsFilters(this.claimsGraphFilters);
    this.resetData();
  }

  totalData(data) {
    let total = data.reduce((acc, val) => acc + val);
    total = total.toString();
    total = total.split(/(?=(?:...)*$)/);
    total = total.join('.');
    return total
  }
}
